export enum EDefinitionType {
    LEAVE_TYPE = 'LEAVE_TYPE',
    EMPLOYEE_TYPE = 'EMPLOYEE_TYPE',
    POSITION = 'POSITION'
}